import { render, staticRenderFns } from "./EditOnClickField.vue?vue&type=template&id=9587c554&"
import script from "./EditOnClickField.vue?vue&type=script&lang=ts&"
export * from "./EditOnClickField.vue?vue&type=script&lang=ts&"
import style0 from "./EditOnClickField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports